import * as api from '../dealerApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  dealerActionCreators,
  DealerActionKeys,
  IPreseasonTargetUpdateResponse,
  UpdatePreseasonTarget
  } from '..';

function* updateProgramsSaga(action: UpdatePreseasonTarget) {
  const response: IPreseasonTargetUpdateResponse = yield call(api.updateProgram, action.payload);

  yield put(
    dealerActionCreators.setPreseasonTarget({
      accountNum: action.payload.accountNum,
      brand: action.payload.brand,
      fiscalYear: action.payload.year,
      programTargetLevelId: response.value.programTargetLevelId
    })
  );
}

export function* watchUpdateProgram() {
  yield takeEvery(DealerActionKeys.UPDATE_DEALER_PROGRAM, updateProgramsSaga);
}
